export default "__VITE_ASSET__a18eXtzM__"